import { createTelemetryAPI } from '~/utils/telemetry'

export const activeQPSTelemetry = createTelemetryAPI(({ track }) => ({
  search(payload: { text: string }) {
    return track('Active QPS: Search', payload)
  },
  changeThreshold(payload: { threshold: number }) {
    return track('Active QPS: Change Threshold', payload)
  },
  changeDate(payload: { beginDate: string | null; endDate: string | null }) {
    return track('Active QPS: Change Date', payload)
  },
  changeFilters(payload: { filterType: string; filterValue: string[] }) {
    return track('Active QPS: Change Filters', payload)
  },
  changeSort(payload: { sort: string; order: string }) {
    return track('Active QPS: Change Sort', payload)
  },
  viewClusterDetail() {
    return track('Active QPS: Click View Cluster Detail')
  },
  changePagination(payload: { page: number; pageSize: number }) {
    return track('Active QPS: Change Pagination', payload)
  }
}))
